import googleAnalytics from './googleAnalytics';
import googleTagManager, { GoogleTagManager } from './googleTagManager';
import { TrackingEventData } from './types';

import { PopTrackingEventsResponse } from 'Api/SiteApi/Responses';

export const GOOGLE_TRACKING_ENABLED = googleAnalytics.isActive || googleTagManager.isActive;

const trackQuickPickButtonClicked = (lotterySlug: string) => {
    if (GOOGLE_TRACKING_ENABLED) {
        const eventParams = {
            lotterySlug,
        };
        GoogleTagManager.gtag('event', 'QuickPickButtonClicked', eventParams);
    }
};

export function prepareTrackingEventsResponse(response: PopTrackingEventsResponse): PopTrackingEventsResponse {
    const { trackingEvents, metaData } = response;

    return { trackingEvents, metaData };
}

/**
 * Prevents duplicate unique events from being sent when they might be generated multiple times due to a page refresh.
 */
export function eventAlreadyProcessedInSession(eventData: TrackingEventData): boolean {
    if (!eventData.transaction_id) {
        return false;
    }

    const KEY_NAME = 'unique_tracking_event_list';
    const eventId = eventData.transaction_id;
    const storedEvents = (sessionStorage.getItem(KEY_NAME) ?? '').split(',').filter(Boolean);
    if (storedEvents.includes(eventId)) {
        return true;
    }

    storedEvents.push(eventId);
    sessionStorage.setItem(KEY_NAME, storedEvents.join(','));

    return false;
}

export default trackQuickPickButtonClicked;
